var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$root.deferredInstallPrompt)?_c('button',{staticClass:"btn btn-primary btn-block p-2 btn-notifications",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.install()}}},[_vm._v(_vm._s(_vm.$t('translations.add_to_home_screen')))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }